import "dayjs/locale/fr";
import DateTimePickerRoot from "react-native-ui-datepicker";
import { DatePickerProps } from "./DatePicker";
import { View } from "react-native";
import { useEffect, useRef } from "react";
import { useTheme } from "../../hooks/use-theme";
import dayjs from "dayjs";
import { useI18n } from "../../hooks/i18n-hooks";
import Icon from "../Icon";

export const hasWebNativeDatePicker = (() => {
    const input = document.createElement("input");
    input.type = "date";

    // Check if the browser recognizes `type="date"`
    const supportsDateInput = input.type === "date";

    // Check if the `showPicker` method exists
    const supportsShowPicker = typeof input.showPicker === "function";

    input.remove();

    return supportsDateInput && supportsShowPicker;
})();

export const DatePicker = ({
    date,
    minimumDate,
    maximumDate,
    isVisible,
    onConfirm,
    onCancel,
    onHide,
    testID,
}: DatePickerProps) => {
    const { marginSize, colors } = useTheme();
    const i18n = useI18n();
    const inputRef = useRef<HTMLInputElement>(null);

    useEffect(() => {
        if (isVisible) {
            inputRef.current?.showPicker();
        }
    }, [isVisible]);

    return hasWebNativeDatePicker ? (
        <input
            type="date"
            id={testID}
            min={minimumDate?.toISOString().split("T")[0]}
            max={maximumDate?.toISOString().split("T")[0]}
            onChange={(e) => {
                const newDate = e.target.valueAsDate;
                if (newDate) {
                    onConfirm(newDate);
                } else {
                    onConfirm(null);
                }
            }}
            style={{
                position: "absolute",
                height: "100%",
                minWidth: "100%",
                opacity: 0,
            }}
            ref={inputRef}
        />
    ) : isVisible ? (
        <View style={{ zIndex: 1 }}>
            <View
                style={{
                    position: "absolute",
                    marginTop: marginSize,
                    top: "100%",
                    left: 0,
                    width: 330,
                    backgroundColor: colors.background,
                    padding: 12,
                    borderRadius: 16,
                    shadowRadius: 20,
                    shadowColor: "#000",
                    shadowOpacity: 0.1,
                    shadowOffset: { width: 0, height: 0 },
                }}
            >
                <DateTimePickerRoot
                    mode="single"
                    selectedItemColor={colors.secondary}
                    buttonPrevIcon={<Icon name="back" />}
                    buttonNextIcon={<Icon name="arrow-right" />}
                    date={date || dayjs(maximumDate?.toISOString().split("T")[0])}
                    firstDayOfWeek={1}
                    minDate={
                        minimumDate ? dayjs(minimumDate?.toISOString().split("T")[0]) : undefined
                    }
                    maxDate={
                        maximumDate ? dayjs(maximumDate?.toISOString().split("T")[0]) : undefined
                    }
                    locale={i18n.locale}
                    onChange={(params) => {
                        const newDate = dayjs(params.date).toDate();
                        if (date) {
                            newDate.setHours(date.getHours());
                            newDate.setMinutes(date.getMinutes());
                        }
                        onConfirm(newDate);
                        onHide?.(newDate);
                        onCancel();
                    }}
                />
            </View>
        </View>
    ) : null;
};
